import { render, staticRenderFns } from "./DocumentTypeTypeahead.vue?vue&type=template&id=53149c0d&scoped=true&"
import script from "./DocumentTypeTypeahead.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeTypeahead.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeTypeahead.vue?vue&type=style&index=0&id=53149c0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53149c0d",
  null
  
)

export default component.exports